import { z } from "zod";

export const momboxLastConnectionDateDtoSchema = z.object({
  momboxId: z.number(),
  lastConnectionDate: z.coerce.date(),
});

export type TMomboxLastConnectionDateDto = z.infer<typeof momboxLastConnectionDateDtoSchema>;
